import { makeStyles, Theme, createStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      backgroundColor: 'transparent',
      paddingTop: 32,
      paddingBottom: 48,
      paddingLeft: 40,
      paddingRight: 40,
      display: 'flex',
      justifyContent: 'start',
      [theme.breakpoints.down('sm')]: {
        paddingLeft: 15,
        paddingRight: 15,
      },
    }
  }),
)
